import { CART_EVENTS, onCartEvent } from "./cart-events.js";

const SELECTORS = {
  closeButton: "[data-cn-close]",
  title: "#cart-notification-title",
  variant: "#cart-notification-variant",
  image: "#cart-notification-image",
};

class CartNotification extends HTMLElement {
  #callbackFunctions = [];
  #timer = null;

  connectedCallback() {
    this.#bindElements();
    this.#bindEvents();
  }

  #bindElements() {
    this.closeButton = this.querySelector(SELECTORS.closeButton);
  }

  #bindEvents() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.close.bind(this));
    }

    this.#callbackFunctions.push(
      onCartEvent(CART_EVENTS.ITEM_ADDED, (detail) =>
        this.onCartItemAdded(detail),
      ),
    );
  }

  onCartItemAdded(detail) {
    const addedItem = detail?.addedItemData;
    if (!addedItem) return;
    this.renderNotification(addedItem);
    this.open();
  }

  renderNotification(addedItem) {

    const title = this.querySelector(SELECTORS.title);
    const variant = this.querySelector(SELECTORS.variant);
    const image = this.querySelector(SELECTORS.image);
    if (title) title.textContent = addedItem.product_title;
    if (variant && addedItem.variant_title && addedItem.variant_title !== "Default Title") {
      variant.textContent = addedItem.variant_title;
    } else if (variant) {
      variant.textContent = "";
    }

    if (image && addedItem.image) {
      image.src = addedItem.image;
      image.alt = addedItem.product_title;
    }
  }

  open() {

    this.classList.remove("opacity-0");
    this.classList.add("is-active");

    if (this.#timer) clearTimeout(this.#timer);
    this.#timer = setTimeout(() => this.close(), 5000);
  }

  close() {
    this.classList.remove("is-active");
    setTimeout(() => this.classList.add("opacity-0", ""), 300);
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #cleanup() {
    this.#callbackFunctions.forEach((fn) => fn());
    this.#callbackFunctions = [];
    if (this.#timer) clearTimeout(this.#timer);
  }
}

if (!customElements.get("cart-notification")) {
  customElements.define("cart-notification", CartNotification);
}
